<template>
  <div class="preview-box creative-preview">
    <template v-if="creativeForm.dynamic_creative_name">
      <Divider title="创意形式"></Divider>
      <LabelRow label="创意名称：">{{ creativeForm.dynamic_creative_name }}</LabelRow>
      <LabelRow label="描述：">
        <p v-for="(d, index) in creativeForm.description_component_options" :key="index">{{ d.value }}</p>
      </LabelRow>
    </template>
  </div>
</template>

<script setup>
import { inject, computed } from 'vue'
import Divider from '@/views/create/bytedance/components/layout/title-divider.vue'
import LabelRow from '@/views/create/bytedance/components/layout/label-row.vue'

// eslint-disable-next-line
const props = defineProps({
  form: Object
})
const { configForm } = inject('configForm')
const creativeForm = computed(() => configForm.value.creativeForm)
</script>

<style lang="scss" scoped>
.preview-box {
  height: 720px;
  overflow: auto;
  padding: 10px;
}
.creative-preview {
  p,
  .el-switch {
    margin-bottom: 5px;
  }
}
</style>
